import { useGetEventDetailsQuery } from "@app/data/eventDetails/eventDetailsApi";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DetailedEventInSearchDto } from "@app/data/tribeSwaggerApi";

export const useGetDetailEvent = (id: string): DetailEventState => {

  const { isLoading, error, data } = useGetEventDetailsQuery(id)
  const navigate = useNavigate();

  useEffect(() => {
    if (error){
      navigate("/service-error")
    }
  }, [error])
  return {
    data: data,
    isLoading: isLoading,
  }
}

export type DetailEventState = {
  isLoading: boolean
  data?: DetailedEventInSearchDto
}
